import CustomButton from "components/CustomButton/CustomButton";
import {
	ActionGroup,
	HeaderActions,
	HeaderGrid,
	HeaderMetaText,
	HeaderStatusBlock,
	HeaderTitle,
	HeaderTitleBlock,
	StatusBlockLabel,
	StatusCluster,
	StatusPill,
	Eyebrow,
} from "../styles";

const OperationalHeader = ({
	currentBatchStatusText,
	currentBatchStatusVariant,
	lastExecutionText,
	canReprocessGlobal,
	canEditConfiguration,
	isBusy,
	onEditCertification,
	onGlobalReprocess,
}) => {
	return (
		<HeaderGrid>
			<HeaderTitleBlock>
				<Eyebrow>Centro de control</Eyebrow>
				<HeaderTitle>Generación automática de constancias</HeaderTitle>
			</HeaderTitleBlock>

			<HeaderStatusBlock>
				<StatusBlockLabel>Estado</StatusBlockLabel>
				<StatusCluster>
					{currentBatchStatusText ? (
						<StatusPill $variant={currentBatchStatusVariant}>
							{currentBatchStatusText}
						</StatusPill>
					) : (
						<StatusPill $variant="neutral">Sin lote</StatusPill>
					)}
					<HeaderMetaText>{lastExecutionText}</HeaderMetaText>
				</StatusCluster>
			</HeaderStatusBlock>

			<HeaderActions>
				<ActionGroup>
					<CustomButton
						variant="quintinary"
						size="small"
						text="Editar configuración"
						disabled={!canEditConfiguration || isBusy}
						onClick={onEditCertification}
					/>
				</ActionGroup>
				<ActionGroup>
					<CustomButton
						text="Reprocesar todos"
						variant="secondary"
						size="small"
						disabled={!canReprocessGlobal || isBusy}
						onClick={onGlobalReprocess}
					/>
				</ActionGroup>
			</HeaderActions>
		</HeaderGrid>
	);
};

export default OperationalHeader;
